export const isAuthenticated = (state) => {
    if (state.auth.auth.message) return true;
    return false;
};
